import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TableContext = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

export default TableContext;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Table/TableContext.js
// module id = 853
// module chunks = 2